var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartTitle",staticClass:"\n    items-center\n    text-xs\n    font-bold\n    uppercase\n    tracking-wide\n    opacity-50\n    chart-title\n    my-1\n    flex-auto\n  "},[_vm._v(" "+_vm._s(_vm.titleToDisplay)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }